import { createRoot } from "react-dom/client";
import App from "./App.tsx";

// Self-host Nunito so html-to-image can reliably embed it during PNG export
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/500.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";

import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
